// extracted by mini-css-extract-plugin
export var centerText = "_6a-8";
export var container = "_6a-0";
export var doughnutContainer = "_6a-7";
export var legend = "_6a-a";
export var legendItemColorDisplay = "_6a-b";
export var legendItemLabel = "_6a-d";
export var legendItemValue = "_6a-c";
export var lg = "_6a-5";
export var maxWidth = "_6a-9";
export var md = "_6a-4";
export var responsive = "_6a-6";
export var sm = "_6a-3";
export var xs = "_6a-2";
export var xxs = "_6a-1";